import React, { memo, useState } from "react";

import NoData from "../../common-components/no-data";
import HiringsTable from "./hirings-table";
import HiringsTableRatio from "./hirings-table-ratio";
import HiringsChart from "./hirings-chart";
import HiringsChartRatio from "./hirings-chart-ratio";
import DicotomicButton from "../../../../../components/dicotomic-button";
import { ArticleContainer, SectionContainer } from "../../clients-dashboard-style";
import { IGetHiringsData } from "../../../../../services/ClientsDashboardServices.dto";
import { UseGenerateDataError } from "../../hooks/useGenerateData.types";

interface HiringsDashboardProps {
  data: IGetHiringsData | null;
  error: UseGenerateDataError;
}

const areEqual = (prevProps: HiringsDashboardProps, nextProps: HiringsDashboardProps) => {
  const isEqualData = JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  const isEqualErrorMessage = prevProps.error.hirings === nextProps.error.hirings;
  return isEqualData && isEqualErrorMessage;
};

const HiringsDashboard = memo(({ data, error }: HiringsDashboardProps) => {
  if (error.hirings) {
    return <NoData message={error.hirings} />;
  }

  if (!data || Object.keys(data).length < 1) {
    return <NoData message="Genera una búsqueda para mostrar datos" />;
  }

  if (data.overallHiringRequestsResults.totalHiringRequests === 0) {
    return <NoData message="No existen datos para las fechas seleccionadas" />;
  }

  const [chartType, setChartType] = useState<"general" | "ratio">("general");

  return (
    <>
      <div className="filter-container">
        <DicotomicButton
          options={[
            { code: "general", label: "General" },
            { code: "ratio", label: "Ratio" },
          ]}
          initialValue={chartType}
          onChange={(value: "general" | "ratio") => setChartType(value)}
        />
      </div>
      {chartType === "general" && (
        <SectionContainer>
          <ArticleContainer>
            <HiringsTable data={data} />
          </ArticleContainer>
          <ArticleContainer>
            <HiringsChart data={data} />
          </ArticleContainer>
        </SectionContainer>
      )}

      {chartType === "ratio" && (
        <SectionContainer>
          <ArticleContainer>
            <HiringsTableRatio data={data} />
          </ArticleContainer>
          <ArticleContainer>
            <HiringsChartRatio data={data} />
          </ArticleContainer>
        </SectionContainer>
      )}
    </>
  );
}, areEqual);

export default HiringsDashboard;
